import { useState } from "react";
import { withNamespaces } from "react-i18next";
import { Button } from "reactstrap";
import { useDsrDeadlineActions } from "../../hooks/useDsrDeadlineActions";
import { useDsrDeadlineWorkflow } from "../../hooks/useDsrDeadlineWorkflow";
import { canEditDsrDeadline, formatDeadlineDate, getWaitingDurationLabel } from "../../utils";
import ResumeWorkflowModal from "../resume-workflow-modal";

const AwaitingRequesterBanner = ({ t, caseId, report }) => {
  const { isAwaitingRequester, data } = useDsrDeadlineWorkflow(caseId);
  const { resumeWorkflow } = useDsrDeadlineActions(caseId, t);
  const [isResumeModalOpen, setIsResumeModalOpen] = useState(false);
  const canEdit = canEditDsrDeadline(report);

  if (!isAwaitingRequester) {
    return null;
  }

  return (
    <>
      <ResumeWorkflowModal
        isOpen={isResumeModalOpen}
        isLoading={resumeWorkflow.isLoading}
        onClose={() => setIsResumeModalOpen(false)}
        onConfirm={() => {
          resumeWorkflow.mutate(undefined, {
            onSuccess: () => setIsResumeModalOpen(false),
          });
        }}
      />
      <div className="dsr-deadline-waiting dsr-deadline-waiting--banner">
        <div className="dsr-deadline-waiting__intro">
          <div className="d-flex align-items-center flex-wrap gap-2">
            <div className="dsr-deadline-card__label mb-0">
              {t("Awaiting requester clarification")}
            </div>
            <span className="dsr-deadline-waiting__badge">{t("Waiting")}</span>
          </div>
          <p className="dsr-deadline-card__hint">
            {t("The workflow is waiting for additional information from the requester.")}
          </p>
        </div>
        <div className="dsr-deadline-waiting__meta">
          <div>
            <div className="dsr-deadline-card__label">{t("Waiting since")}</div>
            <div className="dsr-deadline-card__value">
              {formatDeadlineDate(data?.awaiting_requester_started_at)}
            </div>
          </div>
          <div>
            <div className="dsr-deadline-card__label">{t("Elapsed waiting time")}</div>
            <div className="dsr-deadline-card__value">
              {getWaitingDurationLabel(data?.awaiting_requester_started_at, t)}
            </div>
          </div>
          <div>
            <div className="dsr-deadline-card__label">{t("Reason")}</div>
            <div className="dsr-deadline-card__value">
              {data?.awaiting_requester_reason || "—"}
            </div>
          </div>
        </div>
        {canEdit && (
          <Button
            color="primary"
            outline
            className="dsr-deadline-waiting__action"
            onClick={() => setIsResumeModalOpen(true)}
          >
            {t("Resume workflow")}
          </Button>
        )}
      </div>
    </>
  );
};

export default withNamespaces()(AwaitingRequesterBanner);
